import moment from "moment";

export const generateDateTimeInfo = (inputDate: string | undefined): string => {
    if (inputDate === undefined) {
        return "";
    }
    const momentInputDate = moment(inputDate);

    const isSameDate = momentInputDate.isSame(Date.now(), "date"); // Checking same date
    if (isSameDate) {
        return momentInputDate.format("h:mm a");
    } else if (momentInputDate.isSame(Date.now(), "week")) {
        // Checking same week
        return momentInputDate.format("ddd");
    } else if (momentInputDate.isSame(Date.now(), "year")) {
        // Checking same year
        return momentInputDate.format("MMM D");
    } else {
        return momentInputDate.format("DD MMM YYYY");
    }
};

export const convertDateToString = (inputDate: string | undefined): string => {
    if (inputDate === undefined || inputDate === "") {
        return "";
    }
    const momentInputDate = moment(inputDate);
    return momentInputDate.format("DD MMM YYYY HH:mm:ss");
};

export const convertDateToStringWithTime = (inputDate: string | undefined): string => {
    if (inputDate === undefined || inputDate === "") {
        return "";
    }
    const momentInputDate = moment(inputDate);
    return momentInputDate.format("h:mm a");
};
